/* eslint-disable @next/next/no-img-element */
import Link from "next/link";
import UserAuth from "./UserAuth";
// import Search from "./Search";
import Cookies from "js-cookie";
import SelectCity from "./SelectCity";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { ModalContext } from "@/pages/_app";
import { useContext, useEffect, useRef, useState } from "react";
import { useHandshake } from "@/hooks/useHandshake";
import { useCategoryTree } from "@/hooks/useCategoryTree";
import { AppContext } from "@/contexts/appContexts";
import { useCart } from "@/contexts/cart/CartContext";
import { useCheckIfAuth } from "@/hooks/useCheckIfAuth";
import dynamic from "next/dynamic";
import { event_page_viewed } from "@/utils/gtm";
import ImgTag from "../Helpers/ImgTag";
import TopHeader from "./TopHeader";
import HeaderBanner from "./HeaderBanner";

import AlgoliaSearch from "./AlgoliaSearch";
// import { isWishListArray } from "@/utils/global";
import SaudiIcon from "../icons/SaudiIcon";
import NewUserIcon from "../icons/NewUserIcon";
import LocationIcon from "../icons/LocationIcon";
import CustomerServiceIcon from "../icons/CustomerServiceIcon";
// import TelephoneIcon from "../icons/TelephoneIcon";
import EniIcon from "../icons/EniIcon";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import { MdKeyboardArrowDown } from "react-icons/md";

const CartPopUp = dynamic(() => import("./CartPopup"), { ssr: false });

function Header({
  t,
  offCanvas,
  setOffCanvas,
  offCanvasFromDesktop,
  setOffCanvasFromDesktop,
  // searchValue,
  // onSearch,
  showSearchBoxModal,
  setShowSearchBoxModal,
  citiesToSlect,
  setcitiesToSlect,
  invalidate: invalidateRegions,
  isLoadingRegions,
  homeJson,
  searchInputRef,
  openSearchTermsRef,
}) {
  const { data: session, status } = useSession();
  const { asPath, pathname, query, push, events, locale: lang } = useRouter();
  const {
    setCategoryData,
    setAvailableProductDate,
    setIsCityHavefastDelivery,
  } = useContext(AppContext);
  const Context = useContext(ModalContext);
  const { cart } = useCart();
  const cartRef = useRef();
  const [fetchCheckIfAuth, setFetchCheckIfAuth] = useState(false);
  const [showCart, setShowCart] = useState(false);
  useOnClickOutside([cartRef], () => showCart && setShowCart(false));
  const [showLangDropdown, setShowLangDropdown] = useState(false);

  const { invalidate } = useHandshake(lang, Cookies, false);
  const { invalidate: invalidateCategoryTree } = useCategoryTree(
    lang,
    setCategoryData
  );
  useCheckIfAuth(status === "authenticated", fetchCheckIfAuth);

  useEffect(() => {
    // Skip pages that fire their own specific view events to avoid duplicates
    // const pagesWithOwnViewEvent = [
    //   "/product/[rewrite_url]", // fires product_viewed
    //   "/cart",                  // fires cart_viewed
    //   "/[...catId]",           // fires category_viewed
    //   "/cp/[...categoryUrlKey]", // fires category_viewed
    // ];
    // if (pagesWithOwnViewEvent.includes(pathname)) {
    //   return;
    // }
    // Wait until next-auth has resolved the session before reporting login
    // state. On a cold reload the effect would otherwise run while the session
    // is still loading (session === null) and report is_login = "no" for a
    // logged-in user — and never re-fire, since the deps didn't change.
    if (status === "loading") {
      return;
    }
    console.log("[GTM] Firing page_viewed for", pathname);

    const is_login = session ? "yes" : "no";
    const user = session?.user;
    const phoneNumber = user?.custom_attributes?.find(
      (att) => att.attribute_code == "mobilenumber"
    )?.value;
    event_page_viewed(
      "SAR",
      lang,
      is_login,
      user?.id || null,
      user?.email || null,
      phoneNumber || null
    );
  }, [pathname, status]);

  useEffect(() => {
    if (status !== "authenticated") return;
    // The server owns the cookie now; re-sync it if it was lost mid-session.
    fetch("/api/auth/sync-mage", { method: "POST" }).catch(() => {});
  }, [status]);

  useEffect(() => {
    setFetchCheckIfAuth(true);
  }, []);

  const [changeLang, setChangeLang] = useState(lang);

  const handleSetNetHandshake = () => {
    const locale = lang === "en" ? "ar" : "en";
    events.on("routeChangeComplete", async () => {
      invalidate();
      invalidateRegions();
      invalidateCategoryTree();

      const {
        // setRegionAndCity,
        fetchDeliveryDates,
        setFirstAvailableDate,
        checkFastDeliveryAvailability,
      } = await import("@/utils/global");

      const id = Cookies.get("region_id");

      if (!id || isNaN(id)) return;

      // setRegionAndCity({ id });

      const availableDates = await fetchDeliveryDates(id);
      await setFirstAvailableDate({
        availableDates,
        locale,
        setAvailableProductDate,
      });

      checkFastDeliveryAvailability({
        id,
        homeJson,
        setIsCityHavefastDelivery,
      });
    });
  };

  // const { wishList } = useContext(AppContext);
  const dynamicStyle =
    process.env.NEXT_PUBLIC_WEBSITE_MODE == "extreme"
      ? "text-red bg-white"
      : "text-blue bg-[#00269A0A] campaign:text-campaignAccent campaign:bg-campaignAccent/[0.04]";
  const dynamicHoveStyle =
    process.env.NEXT_PUBLIC_WEBSITE_MODE == "extreme"
      ? "hover:text-white hover:bg-blue border-white"
      : "transition-all duration-500 hover:scale-90 scale-100";

  return (
    <section
      className={`${
        process.env.NEXT_PUBLIC_WEBSITE_MODE == "extreme"
          ? "bg-[url('https://imgs.dev-almanea.com/media/almanea-pattern-bg-min.webp')] bg-fixed bg-center"
          : "bg-white"
      }`}
    >
      <TopHeader />
      <HeaderBanner />
      <header className="w-[93%] max-[570px]:w-[98%] mx-auto pt-5 pb-3 max-[991px]:py-2 max-[768px]:px-2 min-h-[80px] max-[991px]:min-h-[64px]">
        <div className="flex items-center justify-between gap-x-1">
          <Link
            href="/"
            className="relative overflow-hidden bg-white rounded-md w-36"
          >
            <ImgTag
              src={`${process.env.NEXT_PUBLIC_CLOUD_FLAIR}/w=160&h=90,fit=contain,format=auto/almanea-logo.webp`}
              className="object-contain pe-2 ps-2 w-[100px] h-10 md:w-[160px] md:h-12"
              width={160}
              height={90}
              sizes="(min-width: 340px) 160px, calc(70vw - 93px)"
              alt="Logo"
            />
          </Link>
          <div
            className="flex items-center gap-1 mx-0 max-[570px]:hidden"
            onClick={() => {
              setOffCanvas(!offCanvas);
              setOffCanvasFromDesktop(!offCanvasFromDesktop);
            }}
          >
            <button
              aria-label="Burger Menu"
              className={`block p-2 mx-1 ${dynamicStyle} rounded-full  max-[991px]:hidden `}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                version="1"
                viewBox="0 0 512 512"
                fill="none"
                className={`${dynamicHoveStyle}`}
              >
                <path
                  fill="currentColor"
                  d="M725 4672c-120-42-205-117-258-230l-32-67V744l37-75c46-93 112-158 206-202l67-32h1280l58 23c72 29 172 120 210 191 59 107 57 32 57 1911s2 1804-57 1911c-38 71-138 162-210 191l-58 23-625 2c-573 2-629 1-675-15zm1195-2112V850l-532 2-533 3-3 1695c-1 932 0 1701 3 1708 3 9 120 12 535 12h530V2560zM3070 4671c-30-9-73-29-95-43-53-33-128-115-155-168-46-91-50-139-50-720 0-303 4-571 10-604 30-183 173-326 356-356 33-6 301-10 604-10 581 0 629 4 721 50 54 28 142 111 173 164 57 97 57 98 54 772l-3 619-32 67c-44 94-109 160-202 206l-75 37-625 2c-577 2-630 1-681-16zm1198-938l2-533H3200v1070l533-2 532-3 3-532zM3127 2340c-173-30-318-178-347-356-6-33-10-301-10-604 0-581 4-629 50-721 28-54 111-142 164-173 97-57 98-57 773-54l619 3 75 37c93 46 158 112 202 206l32 67 3 619c3 674 3 675-54 772-31 53-119 136-173 164-92 47-138 50-731 49-305-1-577-5-603-9zm1141-952l-3-533-532-3-533-2v1070h1070l-2-532z"
                  transform="matrix(.1 0 0 -.1 0 512)"
                ></path>
              </svg>
            </button>
            <span
              className={`cursor-pointer ${
                process.env.NEXT_PUBLIC_WEBSITE_MODE == "extreme" &&
                "text-white"
              }`}
            >
              {t("Categories")}
            </span>
          </div>
          <div className="relative justify-center flex-1 -mx-1">
            <div
              className={`max-[991px]:hidden relative min-h-[30px] ${
                process.env.NEXT_PUBLIC_WEBSITE_MODE != "extreme" &&
                "border border-[#D4D4D4]"
              }  mx-4 rounded-md`}
            >
              <AlgoliaSearch
                {...{
                  inputId: "search-box1",
                  showSearchBoxModal,
                  setShowSearchBoxModal,
                  searchInputRef,
                  openSearchTermsRef,
                }}
              />
            </div>
          </div>
          <div className="hidden lg:block">
            <SelectCity
              {...{
                citiesToSlect,
                setcitiesToSlect,
                t,
                lang,
                responsive: false,
                setAvailableProductDate,
                isLoadingRegions,
                homeJson,
              }}
            />
          </div>
          <div
            className={`${
              session ? "min-w-[300px]" : "min-w-fit"
            } max-[991px]:min-w-fit flex items-center justify-end`}
          >
            <div
              ref={cartRef}
              className={`cursor-pointer ${dynamicStyle} duration-200 p-2 rounded-full relative max-[991px]:hidden group ml-2`}
            >
              <AiOutlineShoppingCart
                size="1.5rem"
                className={`w-6 h-6 max-md:size-[18px]  ${dynamicHoveStyle}`}
                onClick={() => setShowCart((prev) => !prev)}
              />
              <span
                suppressHydrationWarning
                className="absolute -top-2 ltr:-right-1 rtl:-left-1 px-1.5 text-sm rounded-full bg-blue campaign:bg-campaignAccent text-white font-semibold group"
              >
                {cart?.itemsQty || ""}
              </span>
              {showCart && (
                <CartPopUp
                  suppressHydrationWarning={true}
                  {...{ items: cart?.cartItems, lang, t, setShowCart }}
                />
              )}
            </div>

            {/* <div
              onClick={() => push("/user/favourites")}
              className={`mx-2 ${dynamicStyle} duration-200  p-2 rounded-full relative max-[991px]:hidden cursor-pointer`}
            >
              <Link href="/user/favourites">
                <AiOutlineHeart size="24px" className={`${dynamicHoveStyle}`} />
              </Link>
              {isWishListArray(wishList)?.length > 0 ? (
                <span className="absolute -top-2 ltr:-right-1 rtl:-left-1 px-1.5 text-sm rounded-full bg-blue text-white font-semibold">
                  {isWishListArray(wishList)?.length}
                </span>
              ) : null}
            </div> */}
            <div className="flex gap-2">
              <a
                href="https://customer.almanea.sa/login/"
                target="_blank"
                className={`p-2 ${dynamicStyle} rounded-full cursor-pointer max-[991px]:mx-1 max-[991px]:hidden`}
              >
               <CustomerServiceIcon
                  aria-label="Headphone"
                  className={`${dynamicHoveStyle} w-6 h-6 text-primary campaign:text-campaignAccent`}
                />
              </a>

              <Link
                href="/branches"
                target="_blank"
                className={`p-2 ${dynamicStyle} rounded-full cursor-pointer max-[991px]:mx-1 max-[991px]:hidden `}
              >

                <LocationIcon
                  aria-label="location"
                  className={`${dynamicHoveStyle} w-6 h-6 text-primary campaign:text-campaignAccent`}
                />

              </Link>
            </div>

            {session ? (
              <UserAuth {...{ session, Cookies }} />
            ) : (
              <span
                onClick={() => Context?.dispatch({ type: "authModal" })}
                className={`p-2 mx-2 rounded-full cursor-pointer max-[991px]:mx-1 ${dynamicStyle} max-[991px]:hidden`}
              >
                <NewUserIcon className={`${dynamicHoveStyle}`} />
              </span>
            )}
            {/* <Link
              onClick={() => {
                setChangeLang(lang === "en" ? "ar" : "en");
                handleSetNetHandshake();
              }}
              href={{ pathname, query }}
              as={asPath}
              locale={lang === "en" ? "ar" : "en"}
              className={`w-12 h-12 duration-200 text-center rounded-full relative max-[991px]:hidden flex items-center justify-center ltr:text-xl rtl:txt-lg`}
            >
              {!changeLang?.includes("en") ? <EniIcon /> : <SaudiIcon />}
            </Link> */}
            <div className="relative max-[991px]:hidden flex items-center gap-1">
              <Link
                onClick={() => {
                  setChangeLang(lang === "en" ? "ar" : "en");
                  handleSetNetHandshake();
                }}
                href={{ pathname, query }}
                as={asPath}
                locale={lang === "en" ? "ar" : "en"}
                className="flex items-center justify-center w-10 h-10 rounded-full"
              >
                {!changeLang?.includes("en") ? <EniIcon /> : <SaudiIcon />}
              </Link>

              <MdKeyboardArrowDown
                size={22}
                className="cursor-pointer"
                onClick={() => setShowLangDropdown((prev) => !prev)}
              />

              {showLangDropdown && (
                <div className="absolute right-0 z-50 mt-2 overflow-hidden bg-white rounded-md shadow-md top-full">
                  <Link
                    href={{ pathname, query }}
                    as={asPath}
                    locale="en"
                    onClick={() => {
                      setChangeLang("en");
                      handleSetNetHandshake();
                      setShowLangDropdown(false);
                    }}
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    العربية
                  </Link>

                  <Link
                    href={{ pathname, query }}
                    as={asPath}
                    locale="ar"
                    onClick={() => {
                      setChangeLang("ar");
                      handleSetNetHandshake();
                      setShowLangDropdown(false);
                    }}
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    English
                  </Link>
                </div>
              )}
            </div>

            <div
              onClick={() => push("/cart")}
              className={`mx-2 max-sm:mx-1 cursor-pointer ${dynamicStyle} duration-200 p-2 rounded-full relative max-[768px]:block max-[991px]:block hidden group`}
            >
              <AiOutlineShoppingCart
                className={`w-6 h-6 max-md:size-[18px]  ${dynamicHoveStyle}`}
              />
              <span
                suppressHydrationWarning
                className={`absolute -top-2 ltr:-right-1 rtl:-left-1 px-1.5 text-sm rounded-full ${dynamicStyle} font-semibold group`}
              >
                {cart?.cartItems?.length || ""}
              </span>
            </div>

            <button
              onClick={() => setOffCanvas(!offCanvas)}
              aria-label="Burger Menu"
              className={`hidden p-2 ms-1 ${dynamicStyle}  rounded-full max-[991px]:block`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                version="1"
                viewBox="0 0 512 512"
                className={`${dynamicHoveStyle} `}
              >
                <path
                  fill="currentColor"
                  d="M725 4672c-120-42-205-117-258-230l-32-67V744l37-75c46-93 112-158 206-202l67-32h1280l58 23c72 29 172 120 210 191 59 107 57 32 57 1911s2 1804-57 1911c-38 71-138 162-210 191l-58 23-625 2c-573 2-629 1-675-15zm1195-2112V850l-532 2-533 3-3 1695c-1 932 0 1701 3 1708 3 9 120 12 535 12h530V2560zM3070 4671c-30-9-73-29-95-43-53-33-128-115-155-168-46-91-50-139-50-720 0-303 4-571 10-604 30-183 173-326 356-356 33-6 301-10 604-10 581 0 629 4 721 50 54 28 142 111 173 164 57 97 57 98 54 772l-3 619-32 67c-44 94-109 160-202 206l-75 37-625 2c-577 2-630 1-681-16zm1198-938l2-533H3200v1070l533-2 532-3 3-532zM3127 2340c-173-30-318-178-347-356-6-33-10-301-10-604 0-581 4-629 50-721 28-54 111-142 164-173 97-57 98-57 773-54l619 3 75 37c93 46 158 112 202 206l32 67 3 619c3 674 3 675-54 772-31 53-119 136-173 164-92 47-138 50-731 49-305-1-577-5-603-9zm1141-952l-3-533-532-3-533-2v1070h1070l-2-532z"
                  transform="matrix(.1 0 0 -.1 0 512)"
                ></path>
              </svg>
            </button>
          </div>
        </div>

        <div className="relative items-center mt-1 hidden max-[991px]:flex gap-2">
          <div
            className={`flex-1 border ${
              process.env.NEXT_PUBLIC_WEBSITE_MODE != "extreme" &&
              "border-[#D4D4D4]"
            } rounded-lg min-h-[30px]`}
          >
            <AlgoliaSearch
              {...{
                inputId: "search-box2",
                showSearchBoxModal,
                setShowSearchBoxModal,
                searchInputRef,
                openSearchTermsRef,
              }}
            />
          </div>
          <SelectCity
            {...{
              citiesToSlect,
              setcitiesToSlect,
              t,
              lang,
              responsive: false,
              setAvailableProductDate,
              isLoadingRegions,
              homeJson,
            }}
          />
        </div>
      </header>
    </section>
  );
}

export default Header;
